import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import App from './App';
import './i18n/config';
import axios from 'axios';
import { setupAxiosInterceptors } from './app/axiosInterceptors';
import { ThemeProvider } from '@mui/material/styles';
import { themeV2 } from './components/theme/themeV2';

// Global correlation ID header for all requests
const cid = (() => {
  try {
    const existing = localStorage.getItem('cid');
    if (existing) return existing;
    const v = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem('cid', v);
    return v;
  } catch {
    return `${Date.now()}`;
  }
})();
axios.defaults.headers.common['X-Correlation-Id'] = cid;

// Setup global axios interceptors
setupAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={themeV2}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

